import api from './Api';

export interface ProductTransfer {
  id: number;
  productId: number;
  productName: string;
  sourceDepositId: number;
  sourceDepositName: string;
  destinationDepositId?: number | null;
  destinationDepositName?: string | null;
  quantity: number;
  status: 'IN_TRANSIT' | 'RECEIVED' | 'CANCELLED';
  dispatchedBy: string;
  receivedBy?: string | null;
  dispatchedAt: string;
  receivedAt?: string | null;
}

export const ProductTransferApi = {
  // This is a live operational list; never serve it from the application's
  // five-minute GET cache.
  inTransit: () => api.get<ProductTransfer[]>('/product-transfers/in-transit', {
    headers: { 'Cache-Control': 'no-cache' },
  }),
  dispatch: (depositId: number, productId: number, quantity: number) =>
    api.post<ProductTransfer>('/product-transfers/dispatch', { depositId, productId, quantity }),
  receive: (transferId: number, destinationDepositId: number, productId: number) =>
    api.post<ProductTransfer>(`/product-transfers/${transferId}/receive`, {
      destinationDepositId,
      productId,
    }),
  receiveMatching: (destinationDepositId: number, productId: number) =>
    api.post<ProductTransfer>('/product-transfers/receive-matching', {
      destinationDepositId,
      productId,
    }),
  cancel: (transferId: number) =>
    api.post<ProductTransfer>(`/product-transfers/${transferId}/cancel`),
};
